export default [
  {
    title: 'CORPORATE',
    icon: 'fas fa-th',
    children: [
      {
        path: '/admin/companies',
        title: 'Company Profile',
        permission: 'view-company-profiles'
      },
      {
        path: '/admin/branches',
        title: 'Branch Profile',
        permission: 'view-branches'
      },
      {
        path: '/admin/bank-profiles',
        title: 'Bank Profile',
        permission: 'view-bank-profiles'
      },
      {
        path: '/admin/address/districts',
        title: 'District',
        permission: 'view-districts'
      },
      {
        path: '/admin/address/communes',
        title: 'Commune',
        permission: 'view-communes'
      },
      {
        path: '/admin/address/villages',
        title: 'Village',
        permission: 'view-villages'
      }
    ]
  },
  {
    title: 'SETTING',
    icon: 'fas fa-cog',
    children: [
      {
        title: 'General',
        path: '/admin/settings',
        permission: 'view-settings'
      },
      {
        path: '/admin/promotions',
        title: 'Promotion',
        permission: 'view-promotions'
      },
      {
        path: '/admin/exchange-rates',
        title: 'Exchange Rate',
        permission: 'view-exchange-rates'
      },
      {
        path: '/admin/currencies',
        title: 'Currency',
        permission: 'view-currencies'
      },
      {
        path: '/admin/approval-request-flows',
        title: 'Approval Request Flow',
        permission: 'view-approval-request-flows'
      }
    ]
  },
  {
    icon: 'fas fa-business-time',
    title: 'menu.humanResource',
    children: [
      {
        title: 'menu.employeeManagement',
        children: [
          {
            path: '/admin/organizational-charts',
            title: 'menu.organizationalChart',
            permission: 'view-organizational-charts'
          },
          {
            path: '/admin/organizational-structures',
            title: 'menu.organizationalStructure',
            permission: 'view-organizational-structures'
          },
          {
            path: '/admin/job-levels',
            title: 'menu.jobLevel',
            permission: 'view-job-levels'
          },
          {
            path: '/admin/job-titles',
            title: 'menu.jobTitle',
            permission: 'view-job-titles'
          },
          {
            path: '/admin/job-details',
            title: 'menu.jobDetail',
            permission: 'view-job-details'
          },
          {
            path: '/admin/nationalities',
            title: 'menu.nationality',
            permission: 'view-nationalities'
          },
          {
            path: '/admin/employee-status',
            title: 'menu.employeeStatus',
            permission: 'view-employee-status'
          },
          {
            path: '/admin/employees',
            title: 'menu.employee',
            permission: 'view-employees'
          },
          {
            path: '/admin/position-hierarchies',
            title: 'menu.positionHierarchy',
            permission: 'view-position-hierachies'
          }
        ]
      },
      {
        title: 'menu.holidayManagement',
        children: [
          {
            path: '/admin/holiday-rules',
            title: 'menu.holidayRule',
            permission: 'view-holiday-rules'
          },
          {
            path: '/admin/holiday',
            title: 'menu.holiday',
            permission: 'view-holiday'
          }
        ]
      },
      {
        path: '/admin/shift-managements',
        title: 'menu.shiftManagement',
        permission: 'view-shift-managements'
      },
      {
        title: 'menu.leaveManagement',
        children: [
          {
            path: '/admin/leave-sub-items',
            title: 'menu.leaveSubItem',
            permission: 'view-leave-sub-items'
          },
          {
            path: '/admin/leave-rules',
            title: 'menu.leaveRule',
            permission: 'view-leave-rules'
          },
          {
            path: '/admin/leave-initial-balances',
            title: 'menu.leaveInitialBalance',
            permission: 'view-leave-initial-balances'
          },
          {
            path: '/admin/leave-records',
            title: 'menu.leaveRecord',
            permission: 'view-leave-records'
          }
        ]
      },
      {
        title: 'menu.attendanceManagement',
        children: [
          {
            path: '/admin/attendance-devices',
            title: 'menu.attendanceDevice',
            permission: 'view-attendance-devices'
          },
          {
            path: '/admin/work-schedules',
            title: 'menu.workSchedule',
            permission: 'view-work-schedules'
          },
          {
            path: '/admin/daily-attendances',
            title: 'menu.dailyAttendance',
            permission: 'view-daily-attendances'
          }
        ]
      },
      {
        title: 'menu.payrollManagement',
        children: [
          { path: '/admin/nssf', title: 'menu.nssf', permission: 'view-nssf' },
          {
            title: 'menu.setup',
            children: [
              {
                path: '/admin/cycle-dates',
                title: 'menu.cycleDate',
                permission: 'view-cycle-dates'
              },
              {
                path: '/admin/payroll-formulars',
                title: 'menu.payrollFormular',
                permission: 'view-payroll-formulars'
              },
              {
                path: '/admin/basic-salary-formulars',
                title: 'menu.basicSalaryFormular',
                permission: 'view-basic-salary-formulars'
              },
              {
                title: 'menu.payrollItems',
                children: [
                  {
                    path: '/admin/allowance-items',
                    title: 'menu.allowanceItem',
                    permission: 'view-allowance-items'
                  },
                  {
                    path: '/admin/deduction-items',
                    title: 'menu.deductionItem',
                    permission: 'view-deduction-items'
                  },
                  {
                    path: '/admin/compensation-items',
                    title: 'menu.compensationItem',
                    permission: 'view-compensation-items'
                  },
                  {
                    path: '/admin/incentive-bonus-items',
                    title: 'menu.incentiveBonusItem',
                    permission: 'view-incentive-bonus-items'
                  },
                  {
                    path: '/admin/ot-items',
                    title: 'menu.otItem',
                    permission: 'view-ot-items'
                  },
                  {
                    path: '/admin/ot-rule-by-shifts',
                    title: 'menu.otRuleByShift',
                    permission: 'view-ot-rule-by-shifts'
                  },
                  {
                    path: '/admin/report-customizations',
                    title: 'menu.reportCustomization',
                    permission: 'view-report-customiztions'
                  },
                  {
                    path: '/admin/payslip-customizations',
                    title: 'menu.payslipCustomization',
                    permission: 'view-payslip-customizations'
                  },
                  {
                    path: '/admin/tax-ranges',
                    title: 'menu.taxRange',
                    permission: 'view-tax-ranges'
                  }
                ]
              }
            ]
          },
          {
            title: 'menu.operation',
            children: [
              {
                path: '/admin/payroll-cycles',
                title: 'menu.payrollCycle',
                permission: 'view-payroll-cycles'
              },
              {
                path: '/admin/fixed-allowances',
                title: 'menu.fixedAllowance',
                permission: 'view-fixed-allowances'
              },
              {
                path: '/admin/fixed-incentive-bonus',
                title: 'menu.fixedIncentiveBonus',
                permission: 'view-fixed-incentive-bonus'
              },
              {
                path: '/admin/monthly-allowances',
                title: 'menu.monthlyAllowance',
                permission: 'view-monthly-allowances'
              },
              {
                path: '/admin/monthly-deductions',
                title: 'menu.monthlyDeduction',
                permission: 'view-monthly-deductions'
              },
              {
                path: '/admin/monthly-compensations',
                title: 'menu.monthlyCompensation',
                permission: 'view-monthly-compensations'
              },
              {
                path: '/admin/monthly-incentive-bonus',
                title: 'menu.monthlyIncentiveBonus',
                permission: 'view-monthly-incentive-bonus'
              },
              {
                path: '/admin/monthly-over-times',
                title: 'menu.monthlyOverTime',
                permission: 'view-monthly-over-times'
              },
              {
                path: '/admin/first-cycle-paids',
                title: 'menu.firstCyclePaid',
                permission: 'view-first-cycle-paids'
              },
              {
                path: '/admin/payroll-calculations',
                title: 'menu.payrollCalculation',
                permission: 'view-payroll-calculations'
              }
            ]
          }
        ]
      }
    ]
  },
  // {
  //   title: 'EMPLOYEE',
  //   icon: 'fas fa-user-tie',
  //   children: [
  //     {
  //       path: '/admin/departments',
  //       title: 'Department',
  //       permission: 'view-departments'
  //     },
  //     {
  //       path: '/admin/positions',
  //       title: 'Position',
  //       permission: 'view-positions'
  //     },
  //     {
  //       path: '/admin/employees',
  //       title: 'Profile',
  //       permission: 'view-employee-profiles'
  //     }
  //   ]
  // },
  {
    title: 'SALE',
    icon: 'fas fa-street-view',
    children: [
      {
        path: '/admin/approval-requests',
        title: 'Approval Request',
        permission: 'view-approval-requests'
      },
      {
        path: '/admin/sale-areas',
        title: 'Sale Area',
        permission: 'view-sale-areas'
      },
      {
        path: '/admin/visitation-route-plans',
        title: 'Shop Visit Plan',
        permission: 'view-visitation-route-plans'
      },
      {
        path: '/admin/location-visitations',
        title: 'Commune Visit Plan',
        permission: 'view-location-visitations'
      }
    ]
  },
  {
    title: 'CUSTOMER',
    icon: 'fas fa-users',
    children: [
      {
        path: '/admin/customer-profiles',
        title: 'Profile',
        permission: 'view-customer-profiles'
      },
      {
        path: '/admin/dealer-grades',
        title: 'Dealer Grade',
        permission: 'view-dealer-grades'
      }
    ]
  },
  {
    title: 'INVENTORY',
    icon: 'far fa-chart-bar',
    children: [
      {
        path: '/admin/warehourses',
        title: 'Warehouse',
        permission: 'view-warehourses'
      },
      {
        title: 'Product',
        children: [
          {
            path: '/admin/product-categories',
            title: 'Category',
            permission: 'view-product-categories'
          },
          {
            path: '/admin/product-groups',
            title: 'Group',
            permission: 'view-product-groups'
          },
          {
            path: '/admin/suppliers',
            title: 'Supplier',
            permission: 'view-suppliers'
          },
          {
            path: '/admin/uom-categories',
            title: 'UOM Category',
            permission: 'view-uom-categories'
          },
          {
            path: '/admin/product-warehouse-storages',
            title: 'Location Storage',
            permission: 'view-product-warehouse-storage'
          },
          {
            path: '/admin/product-profiles',
            title: 'Profile',
            permission: 'view-product-profiles'
          },
          {
            path: '/admin/serial-profiles',
            title: 'Serial Profile',
            permission: 'view-serial-profiles'
          },
          {
            path: '/admin/product-assemblies',
            title: 'Assembly',
            permission: 'view-product-assemblies'
          },
          {
            path: '/admin/product-add-on',
            title: 'Add On',
            permission: 'view-product-add-on'
          },
          {
            path: '/admin/product-specifications',
            title: 'Specification',
            permission: 'view-product-specifications'
          },
          {
            path: '/admin/product-locations',
            title: 'Warehouse',
            permission: 'view-product-locations'
          },
          {
            path: '/admin/product-prices',
            title: 'Price',
            permission: 'view-product-prices'
          },
          // {
          //   path: '/admin/product-pallets',
          //   title: 'Pallet',
          //   permission: 'view-product-pallets'
          // },
          {
            path: '/admin/product-labels',
            title: 'Generate Label',
            permission: 'view-generate-lables'
          },
          {
            path: '/admin/product-histories',
            title: 'History',
            permission: 'view-product-histories'
          }
        ]
      },
      {
        path: '/admin/stock-confirm',
        title: 'Stock Confirmation',
        permission: 'view-stock-confirm'
      },
      {
        path: '/admin/stock-counts',
        title: 'Stock Count',
        permission: 'view-stock-counts'
      },
      // {
      //   path: '/admin/stock-transfers',
      //   title: 'Stock Transfer',
      //   permission: 'view-stock-transfers'
      // },
      {
        path: '/admin/transfer-by-serials',
        title: 'Stock Transfer',
        permission: 'view-transfer-by-serials'
      },
      {
        path: '/admin/stock-return',
        title: 'Stock Return',
        permission: 'view-stock-return'
      },
      {
        path: '/admin/stock-adjustments',
        title: 'Stock adjustment',
        permission: 'view-stock-adjustments'
      },
      {
        path: '/admin/inventory-lists',
        title: 'Inventory List',
        permission: 'view-inventory-lists'
      },
      {
        path: '/admin/summary-inventory-lists',
        title: 'Summary Inventory List',
        permission: 'view-summary-inventory-lists'
      },
      {
        path: '/admin/spare-part-replacements',
        title: 'Spare Part Replacement',
        permission: 'view-spare-part-replacements'
      },
      {
        path: '/admin/write-offs',
        title: 'Write-off',
        permission: 'view-write-offs'
      }
    ]
  },
  {
    title: 'FINANCE',
    icon: 'fas fa-chart-line',
    children: [
      {
        title: 'Purchase Order',
        path: '/admin/purchase-orders',
        permission: 'view-purchase-orders'
      },
      {
        path: '/admin/stock-in',
        title: 'Purchase Invoice',
        permission: 'view-stock-in'
      },
      {
        path: '/admin/payment-vendors',
        title: 'Pay to vendor',
        permission: 'view-pay-to-vendors'
      },
      {
        path: '/admin/quotations',
        title: 'Quotation',
        permission: 'view-quotations'
      },
      {
        path: '/admin/sale-contracts',
        title: 'Sale Contract',
        permission: 'view-sale-contracts'
      },
      {
        path: '/admin/borrowing-spare-parts',
        title: 'Borrowing Spare-part',
        permission: 'view-borrowing-spare-parts'
      },
      {
        path: '/admin/borrowing-spare-part-claims',
        title: 'Borrowing Spare-part Claim',
        permission: 'view-borrowing-spare-parts'
      },
      {
        path: '/admin/whole-sales',
        title: 'Sale Invoice',
        permission: 'view-whole-sales'
      },
      {
        path: '/admin/delivery-orders',
        title: 'Delivery Order',
        permission: 'view-delivery-orders'
      },
      {
        path: '/admin/wholesale-receipts',
        title: 'Receipt',
        permission: 'view-wholesale-receipts'
      },
      {
        path: '/admin/return-to-vendors',
        title: 'Return to vendor',
        permission: 'view-return-to-vendors'
      },
      {
        path: '/admin/return-from-vendors',
        title: 'Return from vendor',
        permission: 'view-return-from-vendors'
      },
      {
        path: '/admin/stock-closes',
        title: 'Close Stock',
        permission: 'view-stock-closes'
      }
    ]
  },
  {
    title: 'BOOKING',
    icon: 'fas fa-user-clock',
    children: [
      {
        path: '/admin/table-profiles',
        title: 'Table Profile',
        permission: 'view-table-profiles'
      },
      {
        path: '/admin/available-schedules',
        // title: 'Available Schedule', boss need to change
        title: 'Service Hour',
        permission: 'view-available-schedules'
      },
      {
        path: '/admin/table-bookings',
        title: 'Table Booking',
        permission: 'view-table-bookings'
      }
    ]
  },
  {
    title: 'RETAIL SALE',
    icon: 'fas fa-cart-plus',
    children: [
      {
        path: '/admin/counters',
        title: 'Counter',
        permission: 'view-counters'
      },
      {
        path: '/admin/mart-sales',
        title: 'Point-of-sale',
        permission: 'view-mart-sales'
      },
      {
        path: '/admin/mart-sales/lists',
        title: 'Sale List',
        permission: 'view-mart-sales'
      },
      {
        path: '/admin/pos/counter-checkouts',
        title: 'Restaurant Sale',
        permission: 'view-restaurant-sales'
      },
      {
        path: '/admin/pos/restaurant-sales',
        title: 'Sale List',
        permission: 'view-restaurant-sales'
      },
      {
        path: '/admin/restaurant-kdu',
        title: 'View KDU',
        permission: 'view-kitchen-display-units'
      }
    ]
  },
  {
    title: 'EXPENSE',
    icon: 'fas fa-file-invoice-dollar',
    children: [
      {
        path: '/admin/expense-categories',
        title: 'Category',
        permission: 'view-expense-categories'
      },
      {
        path: '/admin/expense-items',
        title: 'Expense Item',
        permission: 'view-expense-items'
      },
      {
        path: '/admin/daily-expenses',
        title: 'Daily Expense',
        permission: 'view-daily-expenses'
      }
    ]
  },
  {
    title: 'REPORT',
    icon: 'fas fa-file-invoice',
    children: [
      {
        title: 'Inventory',
        children: [
          {
            path: '/admin/report/stock-in-details',
            title: 'Stock In Detail',
            permission: 'view-stock-in-details'
          },
          {
            path: '/admin/report/stock-in-summaries',
            title: 'Stock In Summary',
            permission: 'view-stock-in-summaries'
          },
          {
            path: '/admin/report/detail-inventory-lists',
            title: 'Detail Inventory List',
            permission: 'view-detail-inventory-lists'
          },
          {
            path: '/admin/report/summary-inventory-lists',
            title: 'Summary Inventory List',
            permission: 'view-summary-inventory-lists'
          },
          {
            path: '/admin/report/product-item-lists',
            title: 'Product Item List',
            permission: 'view-product-item-lists'
          },
          {
            path: '/admin/report/purchase-order-lists',
            title: 'PO List',
            permission: 'view-purchase-order-lists'
          },
          {
            path: '/admin/report/purchase-order-summaries',
            title: 'PO Summary',
            permission: 'view-purchase-order-summaries'
          },
          {
            path: '/admin/report/monthly-sale-items',
            title: 'Monthly Sale Item',
            permission: 'view-monthly-sale-items'
          },
          {
            path: '/admin/report/stock-transfers',
            title: 'Stock Transfer',
            permission: 'view-stock-transfer-reports'
          },
          {
            path: '/admin/report/yearly-sale-items',
            title: 'Yearly Sale Item',
            permission: 'view-yearly-sale-items'
          },
          {
            path: '/admin/report/inventory/product-lists',
            title: 'Product List',
            permission: 'view-report-product-lists'
          },
          {
            path: '/admin/report/inventory/product-serials',
            title: 'Product Serial',
            permission: 'view-report-product-serials'
          },
          {
            path: '/admin/report/inventory/product-addon-info',
            title: 'Product Addon/Sparepart Info',
            permission: 'view-product-add-on'
          }
        ]
      },
      {
        title: 'Finance',
        children: [
          {
            path: '/admin/reports/incomes',
            title: 'Daily Income By Cashier',
            permission: 'view-daily-incomes'
          },
          {
            path: '/admin/reports/income-by-sales',
            title: 'Daily Income By Sale',
            permission: 'view-daily-income-by-sales'
          },
          // {
          //   path: '/admin/reports/daily-cash-flow-and-stocks',
          //   title: 'Daily Cash Flow & Stock Control',
          //   permission: 'view-daily-cash-flow-and-stocks'
          // },
          {
            path: '/admin/reports/sale-items',
            title: 'Daily Sale Item',
            permission: 'view-daily-sale-items'
          },
          {
            path: '/admin/reports/yearly-expense-items',
            title: 'Yearly Expense Item',
            permission: 'view-yearly-expense-items'
          },
          {
            path: '/admin/reports/finance/pay-to-vendors',
            title: 'Pay To Vendor',
            permission: 'view-report-pay-to-vendors'
          },
          {
            path: '/admin/reports/finance/income-statement-details',
            title: 'Income Statement Detail',
            permission: 'view-report-income-statement-details'
          },
          {
            path: '/admin/reports/finance/gross-profit',
            title: 'Gross Profit',
            permission: 'view-report-gross-profits'
          },
          // {
          //   path: '/admin/reports/finance/product-prices',
          //   title: 'Product Price',
          //   permission: 'view-report-product-prices'
          // }
          {
            path: '/admin/reports/finance/sale-by-customer-summaries',
            title: 'Sale By Customer',
            permission: 'view-sale-by-customers'
          },
          {
            path: '/admin/reports/finance/account-receivables',
            title: 'Account Receivable',
            permission: 'view-account-receivables'
          },
          {
            path: '/admin/reports/finance/cash-collections',
            title: 'Cash Collection By Cashier',
            permission: 'view-cash-collection'
          }
        ]
      },
      {
        title: 'Sale',
        children: [
          {
            path: '/admin/reports/sale/visitation-plans',
            title: 'Visitation Plan',
            permission: 'view-visitation-plan-reports'
          }
        ]
      },
      {
        title: 'menu.humanResource',
        children: [
          {
            path: '/admin/report/attendance-details',
            title: 'menu.attendanceDetail',
            permission: 'view-attendance-details'
          },
          {
            path: '/admin/report/attendance-summaries',
            title: 'menu.attendanceSummary',
            permission: 'view-attendance-summaries'
          },
          {
            path: '/admin/report/leave-balances',
            title: 'menu.leaveBalance',
            permission: 'view-report-leave-balances'
          },
          {
            path: '/admin/report/employee-lists',
            title: 'menu.employeeList',
            permission: 'view-report-employee-lists'
          },
          {
            path: '/admin/report/attendance-galleries',
            title: 'menu.attendanceGallery',
            permission: 'view-attendance-galleries'
          }
        ]
      }
    ]
  },
  {
    title: 'SECURITY',
    icon: 'fab fa-expeditedssl',
    children: [
      { path: '/admin/roles', title: 'Role', permission: 'view-roles' },
      { path: '/admin/users', title: 'User', permission: 'view-users' },
      { path: '/admin/login-out', title: 'Login/Out', permission: 'view-login-out' },
    ]
  }
]
